// extracted by mini-css-extract-plugin
export default {"phone_input_label_container":"PhoneInput_phone_input_label_container__OhbFx","error_text":"PhoneInput_error_text__LUoVJ","error_input":"PhoneInput_error_input__dJuBf"};